import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    data: {
        calendariosTurnero: undefined
    }
})

export default function configuracionesReducer(state = initialState, action) {

    if(action.type === ReducerActions.SET_CALENDARIOS_TURNERO){
        return state.setIn(["data", "calendariosTurnero"], action.payload)
    }

    return state
}